var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('AppBar'),_c('v-main',[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1),_c('StatusDialog'),_c('v-overlay',{attrs:{"value":_vm.$store.state.globalLoading,"z-index":"9999"}},[_c('v-progress-circular',{attrs:{"size":70,"width":7,"color":"grey","indeterminate":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }